import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { AuthService } from '@appShared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { EXTERNAL_URIS } from '@appShared/external.uris'
import { environment } from '@appEnvironments/environment'

export interface QuickLink {
   title: string
   description: string
   uri: string
   icon: string
}

@Component({
    selector: 'app-content-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ResourcesComponent {
   quickLinks = SITE_DIRECTORY_ROUTES.content.quickLinks
   quickLinksTitle = this.quickLinks.title

   private _externalUris = EXTERNAL_URIS
   private _internalUris = environment.internalUris
   private _authService = inject(AuthService)

   links: QuickLink[] = [
      {
         title: this._internalUris.sales_portal.title,
         description: 'Orders, inventory, and your dealer sales portal.',
         uri: this._internalUris.sales_portal.uri,
         icon: 'a4d-icon.png'
      },
      {
         title: this._externalUris.team_hub.title,
         description: 'Team resources, announcements, and leader tools.',
         uri: this._externalUris.team_hub.uri,
         icon: 'team-hub-icon.png'
      },
      {
         title: this._externalUris.media_resource_center.title,
         description: 'Videos, images, and marketing media for the field.',
         uri: this._externalUris.media_resource_center.uri,
         icon: 'mrc-icon.png'
      },
      {
         title: this._externalUris.click_up.title,
         description: 'Tasks, projects, and team collaboration.',
         uri: this._externalUris.click_up.uri,
         icon: 'clickup-icon.png'
      },
      {
         title: this._externalUris.southwestern_advantage.title,
         description: 'The public Southwestern Advantage website.',
         uri: this._externalUris.southwestern_advantage.uri,
         icon: 'swa-icon.png'
      }
   ]

   constructor(
      titleService: Title
   ) {
      setTimeout(() => titleService.setTitle(`SWA - ${this.quickLinksTitle}`))
   }

   /*
   * public methods
   * */

   logout() {
      this._authService.logout()
   }
}
